import FILTER_LIST from './Filter.list';
import DROPDOWN_LIST from './Dropdown.list';
import MENU_LIST from './Menu.list';

export default { FILTER_LIST, DROPDOWN_LIST, MENU_LIST };
